import { createEntityAdapter, Dictionary, EntityAdapter, EntityState } from '@ngrx/entity';
import { EduFileInterface } from '../../+models/EduFile.interface';
import { EduContentsActions, EduContentsActionTypes } from '../edu-content/edu-content.actions';
import { EduFilesActions, EduFilesActionTypes } from './edu-file.actions';

export const NAME = 'eduFiles';

export interface State extends EntityState<EduFileInterface> {
  // additional entities state properties
  loaded: boolean;
  loadedForEduContent: Dictionary<boolean>;
  loadedForArtifacts: boolean;
  error?: any;
}

export const adapter: EntityAdapter<EduFileInterface> = createEntityAdapter<EduFileInterface>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
  loadedForEduContent: {},
  loadedForArtifacts: false,
});

export function reducer(state = initialState, action: EduFilesActions | EduContentsActions): State {
  switch (action.type) {
    case EduFilesActionTypes.EduFilesLoaded: {
      return adapter.setAll(action.payload.eduFiles, {
        ...state,
        loaded: true,
      });
    }

    case EduFilesActionTypes.EduFilesLoadedForArtifacts: {
      return adapter.upsertMany(action.payload.eduFiles, {
        ...state,
        loadedForArtifacts: true,
      });
    }

    case EduFilesActionTypes.EduFilesLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    case EduFilesActionTypes.EduFilesForArtifactsLoadError: {
      return { ...state, error: action.payload, loadedForArtifacts: false };
    }

    case EduFilesActionTypes.AddEduFile: {
      return adapter.addOne(action.payload.eduFile, state);
    }

    case EduFilesActionTypes.AddEduFiles: {
      return adapter.addMany(action.payload.eduFiles, state);
    }

    case EduFilesActionTypes.UpdateEduFile: {
      return adapter.updateOne(action.payload.eduFile, state);
    }

    case EduFilesActionTypes.DeleteEduFile: {
      return adapter.removeOne(action.payload.id, state);
    }

    case EduFilesActionTypes.UpsertEduFile: {
      return adapter.upsertOne(action.payload.eduFile, state);
    }

    case EduFilesActionTypes.AddEduFilesForEduContent: {
      const { eduContentId, eduFiles } = action.payload;

      if (!eduFiles) {
        return state;
      }

      return adapter.upsertMany(eduFiles, {
        ...state,
        loadedForEduContent: { ...state.loadedForEduContent, [eduContentId]: true },
      });
    }

    case EduContentsActionTypes.LoadDataSuccess: {
      return state;
    }

    default: {
      return state;
    }
  }
}

export const { selectAll, selectEntities } = adapter.getSelectors();
